import { Link } from "react-router-dom";
import { Brand } from "./ui/Brand";

/** Slim top bar for the onboarding flow (no app shell) */
const OnboardingMarketplaceHeader = () => {
  return (
    <header className="sticky top-0 z-30 border-b border-gray-200/80 bg-white/85 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-5xl items-center justify-between px-4 sm:px-6">
        <Brand />
        <p className="text-meta text-gray-500">
          <span className="hidden sm:inline">Already have an account? </span>
          <Link to="/signin" className="font-medium text-gray-900 hover:text-brand-700">
            Sign in
          </Link>
        </p>
      </div>
    </header>
  );
};
export default OnboardingMarketplaceHeader;
